import React, { useState, useEffect, useRef, Fragment } from "react";
import { useSelector } from "react-redux";
import { SuperContentSelector } from "../../../redux/reducers";
import ButtonSwitcher from "../../../components/ButtonSwitcher";
import Firebase from "../../../firebasehelper";
import { tabs } from "../constants/selections";
import FeedContent from "./FeedContent";
import FeedTags from "./FeedTags";
import FeedPostingEdit from "./FeedPostingEdit";
import "./index.css";

const EditPost = ({
  selectedDate,
  onEdit,
  brand_name,
  postData,
  hex,
  white,
  deletePostBtnRef,
}) => {
  const [tab, setTab] = useState(tabs[0]);
  const [hot_topic_tags, setHotTopicTags] = useState([]);
  const [events, setEvents] = useState([]);
  const [products, setProducts] = useState([]);
  const [articles, setArticles] = useState([]);
  const [feed, setFeed] = useState({});
  const [modificationTracked, setModificationTracked] = useState({});
  const dismissElement = useRef();
  const brand = useSelector((state) => state.brand);
  const superContents = useSelector(SuperContentSelector);
  useEffect(() => {
    if (brand_name) {
      // add post for brand
      Firebase.getAllHotTopics(brand_name, (hot_topics) => {
        let hot_topic_tags = hot_topics.map((topic) => {
          let label = `${topic.starting_monday
            .toDate()
            .toLocaleDateString("en-US", {
              month: "long",
              day: "numeric",
            })} - ${topic.tag || topic.title}`;
          let value = topic;
          return { label, value };
        });
        setHotTopicTags(hot_topic_tags);
      });
      Firebase.getAllEvents(brand_name, (events) => setEvents(events));
      Firebase.getArticlesByBrand(brand_name, (articles) =>
        setArticles(articles)
      );
    } else {
      //add post for super content
      console.log("superContents", superContents);
    }
    if (brand && brand.packages) {
      const packages = brand.packages;
      let bPckgs_ids = Object.keys(brand.packages);
      const pkgs = bPckgs_ids.map((id) => ({ ...packages[id], id }));
      setProducts([...pkgs.filter((item) => item.active)]);
    }
  }, [brand_name]);
  const handleChangeTab = (tab) => {
    setTab(tab);
  };
  const handleClickClose = () => {
    dismissElement.current.click();
  };
  const handleClickEdit = () => {
    onEdit(modificationTracked);
  };
  const handleChangeContent = (content) => {
    setFeed({ ...feed, ...content });
  };
  const handleChangeTags = (tags) => {
    setFeed({ ...feed, ...tags });
  };
  const handleChangeTime = (scheduling) => {
    setFeed({ ...feed, ...scheduling });
  };
  const trackModification = (payload) => {
    setModificationTracked({ ...modificationTracked, ...payload });
  };
  return (
    <div
      className="modal fade add-post-dialog"
      id="edit_feed_modal"
      tabIndex="-1"
      role="dialog"
      aria-labelledby="modal-default-fadein"
      aria-hidden="true"
    >
      <div className="modal-dialog" role="document">
        <div className="modal-content add-post-dialog-content">
          <div className="modal-header">
            <h5 className="modal-title">Edit your post</h5>
            <button
              type="button"
              className="close"
              data-dismiss="modal"
              aria-label="Close"
              ref={dismissElement}
              onClick={handleClickClose}
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div className="modal-body pb-1 ">
            <ButtonSwitcher
              buttonsGroup={tabs}
              currentTab={tab}
              onSwitch={handleChangeTab}
              hex={hex}
              white={white}
            />
            <FeedContent
              onChangeContent={handleChangeContent}
              trackModification={trackModification}
              brand_name={brand_name}
              isVisible={tab === "Feed Content" ? true : false}
              feed={postData}
            />
            <FeedTags
              onChangeTags={handleChangeTags}
              hot_topic_tags={hot_topic_tags}
              trackModification={trackModification}
              articles={articles}
              events={events}
              products={products}
              isVisible={tab === "Feed Tags" ? true : false}
              feed={postData}
            />
            <FeedPostingEdit
              selectedDate={selectedDate}
              trackModification={trackModification}
              onChangeTime={handleChangeTime}
              isVisible={tab === "Feed Posting" ? true : false}
              feed={postData}
            />
          </div>
          <div className="modal-footer footer-container">
            <div className="btn-action-container">
              {tab === "Feed Content" && (
                <Fragment>
                  <button
                    className="btn btn-delete"
                    data-dismiss="modal"
                    onClick={() => {
                      deletePostBtnRef.current.click();
                    }}
                  >
                    Delete X
                  </button>
                  <button
                    type="button"
                    className="btn btn-white btn-brand-hex"
                    style={{
                      "--hover-text-color": "black",
                      "--hover-color": "white",
                      backgroundColor: hex || "white",
                      color: white ? "white" : "black",
                    }}
                    onClick={() => setTab("Feed Tags")}
                  >
                    Next
                  </button>
                </Fragment>
              )}
              {tab === "Feed Tags" && (
                <Fragment>
                  <button
                    type="button"
                    className="btn btn-white"
                    onClick={() => setTab("Feed Content")}
                  >
                    Back
                  </button>
                  <button
                    type="button"
                    className="btn btn-white btn-brand-hex"
                    style={{
                      "--hover-text-color": "black",
                      "--hover-color": "white",
                      backgroundColor: hex || "white",
                      color: white ? "white" : "black",
                    }}
                    onClick={() => setTab("Feed Posting")}
                  >
                    Next
                  </button>
                </Fragment>
              )}
              {tab === "Feed Posting" && (
                <Fragment>
                  <button
                    type="button"
                    className="btn btn-white"
                    onClick={() => setTab("Feed Tags")}
                  >
                    Back
                  </button>
                  <button
                    type="button"
                    className="btn btn-green"
                    data-dismiss="modal"
                    onClick={handleClickEdit}
                  >
                    Save
                  </button>
                </Fragment>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditPost;



// WEBPACK FOOTER //
// ./src/screens/Feeds/components/EditPost.js